import ScenarioList from "./components/ScenarioList";
import { useParams } from "react-router-dom";
import { useReadProjectGroupsScenarios } from "@/libs/react-query/hooks/useScenarioQuery";
import { Skeleton } from "@/components/ui/skeleton";
import ScenarioCreateHeaderButton from "./components/ScenarioCreateHeaderButton";
import { useMemo } from "react";
import { useIsFinancialManager } from "@/hooks/useIsFinancialManager";

export default function ProjectScenario() {
  const { group_id = "" } = useParams();

  const isFinancialManager = useIsFinancialManager();

  const { data, isLoading, isError } = useReadProjectGroupsScenarios(group_id);
  const { scenarios = [] } = data || {};

  const hasConfirmedScenario = useMemo(() => {
    if (!scenarios) return false;
    return scenarios.some((scenario) => scenario.approval_id);
  }, [scenarios]);

  if (isLoading) {
    return (
      <div className="w-full h-80 mt-6 grid grid-cols-2 gap-5">
        <Skeleton className="bg-white" />
        <Skeleton className="bg-white" />
      </div>
    );
  }

  if (isError) {
    return null;
  }

  return (
    <div className="relative">
      <div className="mt-6">
        {scenarios.length === 0 ? (
          <EmptyScenario />
        ) : (
          <ScenarioList scenarios={scenarios} />
        )}
      </div>

      <div className="absolute right-0 -top-[54px] w-auto flex justify-end">
        {isFinancialManager && <ScenarioCreateHeaderButton />}
      </div>
    </div>
  );
}

function EmptyScenario() {
  return (
    <div className="w-full h-24 flex items-center justify-center">
      <p className="text-2xl text-gray-B font-semibold">
        시나리오를 추가해주세요
      </p>
    </div>
  );
}
